module.exports = __webpack_public_path__ + "static/media/ghana_navy_logo.7aa451cc.png";